import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["children", "collapsedHeight", "expandButtonText", "collapseButtonText", "dataTestId"];
import * as React from 'react';
import styles from './ExpanderCommon.module.css';
import varsStyles from '../styles/vars.module.css';
import { ToggleButton } from '../ToggleButton';
import { useExpandedHeight, useExpander, useTransitionDurationVar } from '../hooks';
import { DEFAULT_COLLAPSE_BUTTON_TEXT, DEFAULT_EXPAND_BUTTON_TEXT, DEFAULT_TEST_ID } from '../constants';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ExpanderCommonComponent = (_ref, ref) => {
  let {
      children,
      collapsedHeight,
      expandButtonText = DEFAULT_EXPAND_BUTTON_TEXT,
      collapseButtonText = DEFAULT_COLLAPSE_BUTTON_TEXT,
      dataTestId = DEFAULT_TEST_ID
    } = _ref,
    restProps = _objectWithoutProperties(_ref, _excluded);
  const contentRef = React.useRef(null);
  const {
    expanded,
    onToggle,
    size
  } = useExpander(restProps);
  const expandedHeight = useExpandedHeight(contentRef);
  useTransitionDurationVar(contentRef);
  return /*#__PURE__*/_jsxs("div", {
    className: varsStyles['expander'],
    "data-testid": dataTestId,
    ref: ref,
    children: [/*#__PURE__*/_jsx("div", {
      className: styles['content'],
      ref: contentRef,
      style: {
        maxHeight: expanded ? expandedHeight : collapsedHeight
      },
      children: children
    }), /*#__PURE__*/_jsx("div", {
      className: styles['toggle-container'],
      children: /*#__PURE__*/_jsx(ToggleButton, {
        expanded: expanded,
        onToggle: onToggle,
        size: size,
        expandButtonText: expandButtonText,
        collapseButtonText: collapseButtonText
      })
    })]
  });
};
export const ExpanderCommon = /*#__PURE__*/React.forwardRef(ExpanderCommonComponent);